export const getDisplayCssVars = booleans => {
  const displayCssVars = {};
  for (const key of Object.keys(booleans)) {
    const isDisplayed = booleans[key];
    const newKey = `${key}-display`;
    displayCssVars[newKey] = isDisplayed ? 'revert' : 'none';
  }
  return displayCssVars;
};
//# sourceMappingURL=getDisplayCssVars.js.map